export default class Model {

    async saveAsync() {
        throw new Error('Not implement');
    }
}